export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9310.df68fd43.jpg";